/* jshint ignore:start */
define('services/browsapowa',['require','cookieutil'],function (require) {
    'use strict';
    var cookieutil = require('cookieutil');

    return {
        /**
         * on dom load, check if old ie, show alert if < ie8
         */
        oldBrowserWarning: function() {
            $(function () {
                var ie = (function() {
                    var undef,
                        v = 3,
                        div = document.createElement('div'),
                        all = div.getElementsByTagName('i');

                    while (
                        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
                        all[0]
                    );
                    return v > 4 ? v : undef;
                }());

                if (ie < 8 && !cookieutil.get('dismissedGlobalAlert')) {
                    $('#globalAlert').show();

                    $('#dismissGlobalAlert').on('click', function(e) {
                        $('#globalAlert').fadeOut('slow');
                        cookieutil.set('dismissedGlobalAlert', true, null, '/');
                    });
                }
            });
        },

        /**
         * Once we get this single-paged, this won't be needed anymore...
         * Safari back button stores cached html or something, so verify that backbutton hides loading...
         * @returns {bool} 
         */
        isSafari: function () {
            return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        }
    };
});
/* jshint ignore:end */
;
